import script from "./organizer-event-count-card.vue?vue&type=script&setup=true&lang=js"
export * from "./organizer-event-count-card.vue?vue&type=script&setup=true&lang=js"

import "./organizer-event-count-card.vue?vue&type=style&index=0&id=8ce0fb6c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce0fb6c"]])

export default __exports__